import { SAVE_BASKET_SLTP, SAVE_BROKER_SLTP, SAVE_ORDERS,SAVE_POSITION, SAVE_POSITION_MARGE, GET_ORDER } from '../../util/actionTypes';
const initialState = {basketSLTP:[],brokerSLTP:{},data:[],positions:[],positionMarge:[]};

const ordersReducer = (state =initialState, action) => {
    switch (action.type) {
   
        case SAVE_ORDERS: 
            return {
                ...state,
                data :action.payload, 
            };   

        case SAVE_POSITION: 
            return {
                ...state,
                positions :action.payload, 
           };     
        case SAVE_POSITION_MARGE: 
            return {
                ...state,
                positionMarge :action.payload, 
           };
        case SAVE_BASKET_SLTP: 
            return {
                ...state,
                basketSLTP :action.payload, 
            };
        case SAVE_BROKER_SLTP: 
            return {
                ...state,
                brokerSLTP :action.payload, 
            };
        default:
            return state;
    }
};

export default ordersReducer;
